import Icon from 'veui/components/Icon'
import { IconRecommendation } from 'dls-icons-vue'

Icon.register('recommendation', IconRecommendation)
